import React from 'react'

import { theme } from '../../assets/themes/theme'
import { Typography, Grid, useMediaQuery } from '@mui/material'
import ExpertCard from './ExpertCard'

import { useExpertsBySector } from '../../hooks/experts/useExperts'
import { Expert } from '../../shared/types/expert/Expert'

interface IExpertsBySector {
  sector: string
}

export default function ExpertsBySector({ sector }: IExpertsBySector) {
  const { experts } = useExpertsBySector(sector)
  const isMobileFormat = useMediaQuery(theme.breakpoints.down('md'))

  return (
    <>
      <Typography
        gutterBottom
        pb={1}
        color='#000000'
        fontWeight='bold'
        fontSize={isMobileFormat ? '13px' : '14px'}
        dangerouslySetInnerHTML={{
          __html: sector,
        }}
      />
      <Grid container spacing={1}>
        {experts?.map((expert: Expert) => (
          <Grid item mb={1} xs={6} sm={3} key={expert._id}>
            <ExpertCard
              linkedInUrl={expert.linkedInUrl}
              imageUrl={expert.imageUrl}
              firstName={expert.firstName}
              lastName={expert.lastName}
              poste={expert.poste}
            />
          </Grid>
        ))}
      </Grid>
    </>
  )
}
